import { ChangeDetectionStrategy, Component, OnInit, Optional } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Order } from '~lmo/models/order.model';
import { LmoOrdersService } from '~lmo/services';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-orders-cancel-dialog',
  styleUrls: ['./lmo-orders-cancel-dialog.component.scss'],
  templateUrl: './lmo-orders-cancel-dialog.component.html',
})
export class LmoOrdersCancelDialogComponent implements OnInit {
  private cancelling$$ = new BehaviorSubject<boolean>(false);
  public orderIds: number[];
  public skipLoaded = false;
  public currentOrder$: Observable<Order>;
  constructor(
    private orderService: LmoOrdersService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Optional() private matDialogRef: MatDialogRef<LmoOrdersCancelDialogComponent>,
  ) {}

  public ngOnInit() {
    this.currentOrder$ = this.orderService.currentOrder$;
  }

  public cancel(cancelReason: string) {
    this.cancelling$$.next(true);
    const orderIds = this.orderIds ? this.orderIds : null;
    this.orderService.cancelOrders$(cancelReason, orderIds, this.skipLoaded).subscribe((cancelled) => {
      this.cancelling$$.next(false);
      this.currentOrder$.pipe(take(1)).subscribe((order) => {
        if (order) {
          this.orderService.getOrder(order.id.toString());
        }
      });
      if (this.matDialogRef) {
        this.matDialogRef.close(cancelled);
        return;
      }

      if (cancelled) {
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: {} });
      }
    });
  }
}
